import './App.css';
import React, { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

const Index = lazy(() => import("./official/index"));

export default class App extends React.Component {
    render() {
        return (
            <Router>
                <Suspense fallback="">
                    {/* <Index /> */}
                    <Routes>
                        <Route path="*" element={<Index />}></Route>
                    </Routes>
                </Suspense>
            </Router>
        );
    }
}


// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
